import { render, staticRenderFns } from "./Asignaciones_sede_v7.vue?vue&type=template&id=2e512cf6&scoped=true"
import script from "./Asignaciones_sede_v7.vue?vue&type=script&lang=js"
export * from "./Asignaciones_sede_v7.vue?vue&type=script&lang=js"
import style0 from "./Asignaciones_sede_v7.vue?vue&type=style&index=0&id=2e512cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e512cf6",
  null
  
)

export default component.exports